// extracted by mini-css-extract-plugin
export var childrenContainer = "_4n-0";
export var virtualScrollArea = "_4n-1";